<div class="container ion-padding-vertical" [formGroup]="form">
  <div class="modal">
    <div class="modal-header">
      <h1 class="ion-text-center">{{ 'posManager.productionAreaOverride' | transloco }}</h1>
    </div>

    <div class="modal-content">
      <div class="production-area-modal__form">
        <div>
          <ion-label class="production-area-modal__no-sync-tooltip">{{ 'posManager.productionAreaOverrideNotice' | transloco }}</ion-label>
        </div>
        <ion-list lines="none">
          <ion-radio-group formControlName="selectedArea">
            <ion-item *ngFor="let area of productionAreas">
              <ion-radio slot="start" [value]="area.id"></ion-radio>
              <div class="production-area-modal__item-text">
                <ion-label>{{ area.name }}</ion-label>

                <ion-label *ngIf="originalProductionAreaId === area.id"
                           class="production-area-modal__item-text__original_text">{{ 'posManager.original' | transloco }}</ion-label>
              </div>
            </ion-item>
            <ion-item *ngIf="productionAreas?.length === 0">
              <ion-label>{{ 'posManager.noProductionAreasAvailable' | transloco }}</ion-label>
            </ion-item>
          </ion-radio-group>
        </ion-list>
      </div>
    </div>

    <div class="modal-footer">
      <div class="production-area-modal__actions">
        <ion-button color="clear" (click)="cancel()">{{ 'common.cancel' | transloco }}</ion-button>
        <ion-button color="dark" (click)="save()">{{ 'common.ok' | transloco }}</ion-button>
      </div>
    </div>
  </div>
</div>
